import Vue from './vue-config'

if (document.getElementById('gettingheremap')) {
    new Vue({
        el: '#gettingheremap',
        data: {
            query: '',
            geocoder: null,
            map: null,
            markers: [],
            results: [],
            error: false,
        },
        methods: {
            clearResults() {
                for (var i = 0; i < this.markers.length; i++) {
                    this.markers[i].setMap(null)
                }
                this.markers = []
                this.results = []
            },
            doSearch() {
                var vm = this
                var bounds = new google.maps.LatLngBounds()
                this.clearResults()
                vm.geocoder.geocode({ address: this.query, region: 'EU' }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        vm.error = false
                        var userloc = results[0].geometry.location
                        var m = new google.maps.Marker({
                            draggable: false,
                            animation: google.maps.Animation.DROP,
                            map: vm.map,
                            position: userloc,
                            title: results[0].formatted_address,
                        })
                        bounds.extend(userloc)
                        vm.markers.push(m)
                        vm.doPost('/umbraco/surface/gettinghere/search', { lat: userloc.lat(), lon: userloc.lng() },
                            (data) => {
                                vm.results = data
                                for (var i = 0; i < data.length; i++) {
                                    var loc = new google.maps.LatLng(data[i].LatLon.Lat, data[i].LatLon.Lon)
                                    var m = new google.maps.Marker({
                                        draggable: false,
                                        title: `${data[i].Name} - ${data[i].Title}`,
                                        position: loc,
                                        animation: google.maps.Animation.DROP,
                                        icon: `http://maps.google.com/mapfiles/ms/micons/${data[i].MapIcon}.png`,
                                        map: vm.map,
                                        url: data[i].Link
                                    })
                                    bounds.extend(loc)
                                    vm.markers.push(m)
                                    google.maps.event.addListener(m, 'click', function () {
                                        window.open(this.url, '_blank')
                                    })
                                }
                                vm.map.fitBounds(bounds)
                            })
                    } else {
                        vm.error = true
                        vm.clearResults()
                    }
                })
            }
        },
        mounted() {
            this.geocoder = new google.maps.Geocoder()
            var elem = this.$el.querySelector('.route__map')
            this.map = new google.maps.Map(elem, {
                zoom: 9,
                maxZoom: 18,
                minZoom: 5,
                center: new google.maps.LatLng(49.5799965, -2.3327157),
                panControl: false,
                streetViewControl: false,
                scrollwheel: false,
                mapTypeControl: true,
                gestureHandling: 'greedy',
                mapTypeId: google.maps.MapTypeId.ROADMAP
            })
            if (this.querystringObject.query) {
                this.query = this.querystringObject.query
                this.doSearch()
            }
        }
    })
}